import 'moment-timezone';
import moment from 'moment';

export const formatz = (
    msec: number,
    timezone: string,
    format: string = 'YYYY/MM/DD HH:mm:ss zz',
) => (
        ((msec === null) || (msec === undefined)) ? ('') :
            (moment.tz(msec, timezone).format(format))
    );
